/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */


import * as utils from "./utils.js";


/** Credit - Net pay */
const CATGROUP_INC = 0;
/** Debit - Regular expense */
const CATGROUP_EXP = 1;
/** Credit - Transfer from account */
const CATGROUP_TFA = 2;
/** Debit - Transfer to account */
const CATGROUP_TTA = 3;
/** Credit - Earned Interest */
const CATGROUP_EIT = 4;
/** Debit - Charged Interest */
const CATGROUP_CIT = 5;


const isCredit = 1;
const isDebit = 2;

const catgroupTypes = [
  { type: CATGROUP_INC, groupType: isCredit, desc: "Income", code: "INC" },
  { type: CATGROUP_EXP, groupType: isDebit, desc: "Expense", code: "EXP" },
  { type: CATGROUP_TFA, groupType: isCredit, desc: "Transfer from", code: "TFA" },
  { type: CATGROUP_TTA, groupType: isDebit, desc: "Transfer to", code: "TTA" },
  { type: CATGROUP_EIT, groupType: isCredit, desc: "Earned Interest", code: "EIT" },
  { type: CATGROUP_CIT, groupType: isDebit, desc: "Charged Interest", code: "CIT" },
];


const categories = [
  { hidden: true, code: 0, group: CATGROUP_EXP, longCode: "Unknown", desc: "Unknown" },

  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "General", desc: "General" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Other", desc: "Other" },

  { hidden: false, code: 0, group: CATGROUP_INC, longCode: "Income", desc: "Net Pay" },


  { hidden: true, code: 0, group: CATGROUP_TTA, longCode: "TB", desc: "To banking" },
  { hidden: true, code: 0, group: CATGROUP_TTA, longCode: "TC", desc: "To credit" },
  { hidden: true, code: 0, group: CATGROUP_TTA, longCode: "TI", desc: "To investment" },

  { hidden: true, code: 0, group: CATGROUP_TFA, longCode: "FB", desc: "From banking" },
  { hidden: true, code: 0, group: CATGROUP_TFA, longCode: "FC", desc: "From credit" },
  { hidden: true, code: 0, group: CATGROUP_TFA, longCode: "FI", desc: "From investment" },




  { hidden: true, code: 0, group: CATGROUP_EIT, longCode: "EarnedInterest", desc: "Earned Interest" },
  { hidden: true, code: 0, group: CATGROUP_CIT, longCode: "ChargedInterest", desc: "Charged Interest" },

  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Alcohol", desc: "Alcohol" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Automotive", desc: "Automotive" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Business", desc: "Business" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Cable", desc: "Cable" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Cell", desc: "Cell" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Charity", desc: "Charity" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "ChildCare", desc: "ChildCare" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Clothing", desc: "Clothing" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "CreditCard", desc: "Credit Card" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Dues", desc: "Dues" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Electricity", desc: "Electricity" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Entertainment", desc: "Entertainment" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Gas", desc: "Gas" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Groceries", desc: "Groceries" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Hobbies", desc: "Hobbies" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "HomeImprovement", desc: "Home Improvement" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "HomeMaintenance", desc: "Home Maintenance" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Inctax", desc: "Income Tax" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Insurance", desc: "Insurance" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Internet", desc: "Internet" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Loan", desc: "Personal Loan" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Medical", desc: "Medical" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Memberships", desc: "Memberships" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Miscellaneous", desc: "Miscellaneous" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Mortgage", desc: "Mortgage" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Oil", desc: "Oil" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "PersonalCare", desc: "Personal Care" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "PetCare", desc: "Pet Care" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Phone", desc: "Phone" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Proptax", desc: "Property Tax" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Rent", desc: "Rent" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Restaurants", desc: "Restaurants" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Salestax", desc: "Sales Tax" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "SchoolSupplies", desc: "School Supplies" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "ServiceFees", desc: "Service Fees" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Sports", desc: "Sports" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Subscriptions", desc: "Subscriptions" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Tobacoo", desc: "Tobacoo" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Travel", desc: "Travel" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Tuition", desc: "Tuition" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Vacation", desc: "Vacation" },
  { hidden: false, code: 0, group: CATGROUP_EXP, longCode: "Water", desc: "Water" }
];


export const Categories = {};

Categories.CATGROUP_INC = CATGROUP_INC;
Categories.CATGROUP_EXP = CATGROUP_EXP;
Categories.CATGROUP_TFA = CATGROUP_TFA;
Categories.CATGROUP_TTA = CATGROUP_TTA;
Categories.CATGROUP_EIT = CATGROUP_EIT;
Categories.CATGROUP_CIT = CATGROUP_CIT;



Categories.getCatGroupTypes = function () {
  return catgroupTypes;
}


Categories.getCategories = function () {
  return categories.filter(c => c.hidden === false);
}


Categories.getExpenseCategories = function () {
  return this.getCategories().filter(c => c.group === CATGROUP_EXP);
}


/**
 * Given a category code, return a Category or null if not found
 * @param {string} name
 * @returns {Category} 
 */
Categories.findCategory = function(name) {
  const num_categories = categories.length;

  for (var i = 0; i < num_categories; i++) {
    if (utils.stringCompare(categories[i].longCode, name))
      return categories[i];
  }

  return null;
}



